'use strict';
import constantData from '../../common/constants.js';

export default class categoriesController {
    constructor(UserLoginService,$state,categoriesService){
        this._categoriesService = categoriesService;
        this.uploadShow = false;
        this.csvFile;
        console.log(this.api);

        this.errorMessage = '';
        this.initialize = (form)=>
        {
            //console.log("hello");
            if(form.$valid){
                this.uploadShow = true;
            }else {
                window.alert("please fill the credential first");
            }
        };
        this.upload = (file)=>{
            console.log("IN 111");
           this._uploadCategories(file);
        };

        this.uploadPrice = (file)=>{
            console.log("IN 222");
            this._uploadPrice(file);
        };

   

    }

    

    _uploadPrice = (file) => {
        //let credential = {"api":this.api,"user":this.user,"password":this.password};
        console.log("in controller - _uploadPrice");
        this._categoriesService.updatePrice(file).then((result)=>{
            //console.log("result========>",result);
            window.alert("Discount update Process start successfully. System will notify in registered email once completed.");
            
        }, function(err){
            console.log(err);
            if(err){
                window.alert("Some error");
            }
        });
    };


    _uploadCategories=(file)=>{
        console.log("in controller - _uploadCategories");
        //let credential = {"api":this.api,"user":this.user,"password":this.password}
        this._categoriesService.updateCategories(file).then((result)=>{
            //console.log("result========>",result);
            if(result){
                this.uploadShow = false;
                this.api='';
                this.user='';
                this.password='';
                window.alert("Categories access update Process start successfully. System will notify in registered email once completed.");
        
            }
            else{
                this.MsgBlock = true;
                this.errorMessage = 'Invalid username or password.'
            }
        }, function(err){
            console.log(err);
            if(err){
                window.alert("Please Enter Valid Credentials Or Please check the file that you have uploaded");
            }
        });
    };
}


// WEBPACK FOOTER //
// ./src/app/modules/categories/categories.controller.js